<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="" />
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="" />
      </template>
    </van-nav-bar>
    <div class="goods-list" v-for="(item,index) in goodsList" :key="index">
      <van-card
        :title="item.name"
        :num="item.number"
        :thumb="item.image"
        @click="goDesGood(item.goods_id)"
      />
      <div class="msg-box">
        <van-field v-if="item.finish_comment==0"
                   v-model="item.message"
                   rows="2"
                   style="background: #EFEFEF;"
                   autosize
                   type="textarea"
                   maxlength="256"
                   placeholder="分享评论宝贝，可以帮助更多想买的人"
                   show-word-limit
        />
        <div class="submit-box justify-align" v-if="item.finish_comment==0">
          <div class="left-justifying">
            <van-icon @click="checkClick(index)" :name="item.isCheck? 'checked' : 'circle'" size="20" :color="item.isCheck? '#56BB3B' : '#C9C9C9'" />

            <!--          <van-icon @click="checkClick(index)" v-else name="circle" size="20" />-->

            <span style="margin-left: 1.33333vw;display: inline-block;">匿名提交</span>
          </div>
          <van-button class="submit-btn" size="small" :disabled="item.isDisable" @click="submitComment(item)" type="primary" >提交</van-button>
        </div>
        <div style="padding: 2.66667vw 0;color: #999;" v-if="item.finish_comment==1">您已评价过该商品</div>
      </div>
    </div>


  </div>
</template>

<script>
import {orderComment, orderListDes} from '@/api/order'
export default {
  name: "comment",
  data(){
    return {
      appTheme:this.$store.state.appTheme,
      orderInfo: '',
      message: '',
      isDisable: false,
      goodsList: [],
      checked:0,
      user_id: 0, // 用户id, 值为0则匿名
      orderId: ''
    }
  },
  created() {
    this.orderId = this.$route.query.id
    // var item = this.$route.query.item
    //
    // this.orderInfo = JSON.parse(item)
    this.getInfoOrder()
  },
  methods: {
    goDesGood(id){
      this.$router.push({path:'/goodDetails',query:{id:id}})
    },
    getInfoOrder(){
      orderListDes(this.orderId).then(res => {
        if(res.code == 200)
        {
          this.orderInfo = res.data
          var arr = this.orderInfo.order_goods

          for (let i = 0; i < arr.length; i++) {
            arr[i].message = ''
            arr[i].isCheck  = false,
            arr[i].isDisable =false
          }
          this.goodsList = arr

        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    checkClick(index){
      // console.log(index)
      // console.log('index',this.goodsList[index].isCheck)
      var arr = this.goodsList
      var is_user = arr[index].isCheck
      // arr[index].is_check = c
      if (is_user == false){
        arr[index]['isCheck']=true
        arr[index].number='22'
      } else {
        arr[index].isCheck=false
        arr[index].number ='11'
      }
      this.goodsList = arr
      // console.log('list', this.goodsList)


    },
    submitComment(item){

      var userInfo = this.$store.state.userInfo

      var that =this
      if (item.message == ''){
        this.$toast('请输入评价内容')
        return false
      } else {
        item.isDisable = true // 防止多次提交
        var data = {
          content: item.message,
          user_id: item.isCheck==false? 0:userInfo.id, // 用户id, 值为0则匿名
        }

         orderComment(item.id,data).then(res=>{
           if(res.code == 200)
           {
             this.$toast('评价成功')

             const secounds = 1
             let num = 0
             const timer = setInterval(() => {
               if(num < secounds) {
                 num++
               }else {
                 clearInterval(timer)
                 // this.$router.go(-1);

                 var arr = that.goodsList
                 for (var i=0;i<arr.length;i++){
                   if (item.id == arr[i].id){
                     arr[i].finish_comment=1
                     arr[i].message = ''
                       arr[i].isDisable  = true
                   }
                 }
                 that.goodsList = arr

               }
             }, 1000)// 这里的时间不要忘记，否则没有效果
           }
           else
           {
             this.$toast(res.message)
             this.isDisable= false
             // this.$router.push('/');
           }
         })
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
  }
}
</script>

<style lang="scss" scoped>
.van-card__num{
  opacity: 0;
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.goods-list{
  margin: 20px 24px;background: #FFFFFF;padding: 20px;
  border-radius: 10px;
}
.van-card{
  background: #fff;padding-left: 0;
}
.van-card__price{
  color: #F23926;
}
.msg-box{

  .title{
    font-weight: bold;padding: 20px 0;
  }
  background: #FFFFFF;
  .submit-box{
    padding: 30px 0 10px;
  }
}
.submit-btn{
  display: block;background: #FDD80D;font-size: 30px;
  border-radius:50px;border: none;
  color: #282828;width: 25%;
}
.van-cell{
  border-radius: 8px;
}
textarea::-webkit-input-placeholder {

  color: #909090;
  /* placeholder位置  */
}
</style>
